import React from "react"

const services = [
  {
    icon: "Wp",
    title: "WordPress theme development",
    description:
      "Custom, hand-coded WordPress themes built for speed and easy content editing — no bloated page builders.",
  },
  {
    icon: "Sy",
    title: "Shopify theme development",
    description:
      "Bespoke Shopify themes and section customisation to help your store stand out and convert.",
  },
  {
    icon: "Ee",
    title: "ExpressionEngine development",
    description:
      "Theme builds, template updates and ongoing support for existing ExpressionEngine sites.",
  },
  {
    icon: "Mg",
    title: "Website management",
    description:
      "Core, plugin and security updates, backups and general upkeep so your site stays fast and secure.",
  },
  {
    icon: "Php",
    title: "PHP applications",
    description:
      "Custom PHP applications and integrations built to solve a specific business problem.",
  },
  {
    icon: "Cn",
    title: "Web project consultancy",
    description:
      "Technical planning, scoping and advice to help you (or your agency) plan a web project with confidence.",
  },
]

export default function Services() {
  return (
    <section className="services" id="services">
      <div className="container">
        <div className="services__heading">
          <p className="eyebrow">What I do</p>
          <h2>Services built around what your website actually needs</h2>
          <p>
            I work directly with businesses and agencies, taking projects from a rough idea through to a
            finished, maintained website.
          </p>
        </div>
        <div className="services__grid">
          {services.map((service) => (
            <div className="services__card" key={service.title}>
              <div className="services__card__icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}